// 3rd party
import { Component, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatExpansionPanel } from '@angular/material';
import { Subscription } from 'rxjs/Rx';
import { PdfJsViewerComponent } from 'ng2-pdfjs-viewer';

// components
import { AppComponent } from 'app/app.component';
import { BudgetListComponent } from 'app/budgets/budget-list/budget-list.component';
import { LayoutMainComponent } from 'app/shared/layout/layout-main/layout-main.component';

// helpers
import { Helper } from 'app/shared/helpers/helper';

// models
import { Budget } from 'app/budgets/shared/budgets.model';
import { ContactCustomer, ERoleActionWebview } from 'app/shared/models/contact-customer.model';
import { StoredFile } from 'app/shared/models/stored-file.model';

// services
import { BudgetService } from 'app/budgets/shared/budget.service';
import { DialogsService } from 'app/shared/services/dialog/dialog.service';
import { StoredFileService } from 'app/shared/services/stored-file.service';

@Component({
  selector: 'app-budget',
  templateUrl: './budget.component.html',
  styleUrls: ['./budget.component.css']
})
export class BudgetComponent implements OnInit, OnDestroy {

  @ViewChild('budgetPanel') budgetPanel: MatExpansionPanel;
  @ViewChild('pdfViewer') pdfViewer: PdfJsViewerComponent;

  budget: Budget = new Budget();
  hasBudgetViewPermission: boolean = false;
  isLoading: boolean = false;
  subscribe1: Subscription;

  constructor(
    private activatedRoute: ActivatedRoute,
    private app: AppComponent,
    private budgetListComponent: BudgetListComponent,
    private budgetService: BudgetService,
    public dialog: DialogsService,
    public mainLayout: LayoutMainComponent,
    public router: Router,
    public storedFileService: StoredFileService
  ) { }

  ngOnInit(): void {
    this.budgetPanel.expanded = true;

    this.subscribe1 = this.activatedRoute.params.subscribe(params => {
      let id = params['identifier'];
      if (!id) {
        return;
      }

      this.budgetListComponent.sidenavRight.open();
      this.budgetService.get(id).subscribe(res => {
        this.budget = Helper.deserialize(res.text())[0];
      });
    });

    this.checkPermissions();
  }

  ngOnDestroy() {
    if (this.subscribe1) {
      this.subscribe1.unsubscribe();
    }
    this.budgetListComponent.sidenavRight.close();
  }

  checkPermissions() {
    const contact = JSON.parse(localStorage.getItem('currentContact')) as ContactCustomer;
    this.hasBudgetViewPermission = ContactCustomer.hasPermission(ERoleActionWebview.BudgetsView, contact.RoleWebView.ActionsPermissions);
  }

  close() {
    this.budgetListComponent.sidenavRight.close();
    this.router.navigate([`/${this.app.currentContact.Domain}/budgets/`]);
  }

  view() {
    this.isLoading = true;
    let lstFilters = '"Budget.Identifier_in(\'' + this.budget.Identifier + '\')"';
    let lstFields = '"SystemFileName","UserFileName","Budget.Code"';
    let storedFiles: any[] = [];

    this.storedFileService.get(null, null, null, null, null, null, lstFilters, lstFields)
      .subscribe(value => {
        storedFiles = value.json() as StoredFile[];
        if (!storedFiles || storedFiles.length === 0) {
          this.dialog.error('Message.ErrorAlert', 'Message.ViewBudgetError');
          this.isLoading = false;
        }
        this.storedFileService.download(storedFiles as StoredFile[])
          .subscribe(data => {
            this.isLoading = false;
            if (data) {
              const file = new Blob([data], { type: data.type });

              this.storedFileService.view(file, false, this.pdfViewer, `Orçamento ${this.budget.Code}`);

            } else {
              this.dialog.error('Message.ErrorAlert', 'Message.ViewBudgetError');
            }
          }, () => {
            this.dialog.error('Message.ErrorAlert', 'Message.OpenBudgetError');
            this.isLoading = false;
          });
      }, () => {
        this.dialog.error('Message.ErrorAlert', 'Message.OpenBudgetError');
        this.isLoading = false;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/budgets/budget/budget.component.ts